/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["yo-BJ",[["Àárɔ̀","Ɔ̀sán"]],u,[["À","A","Ì","Ɔ","Ɔ","Ɛ","À"],["Àìkú","Ajé","Ìsɛ́gun","Ɔjɔ́rú","Ɔjɔ́bɔ","Ɛtì","Àbámɛ́ta"],["Ɔjɔ́ Àìkú","Ɔjɔ́ Ajé","Ɔjɔ́ Ìsɛ́gun","Ɔjɔ́rú","Ɔjɔ́bɔ","Ɔjɔ́ Ɛtì","Ɔjɔ́ Àbámɛ́ta"],["Àìkú","Ajé","Ìsɛ́gun","Ɔjɔ́rú","Ɔjɔ́bɔ","Ɛtì","Àbámɛ́ta"]],[["À","A","Ì","Ɔ","Ɔ","Ɛ","À"],["Àìkú","Ajé","Ìsɛ́gun","Ɔjɔ́rú","Ɔjɔ́bɔ","Ɛtì","Àbámɛ́ta"]],[["S","È","Ɛ","Ì","Ɛ̀","Ò","A","Ò","O","Ɔ̀","B","Ɔ̀"],["Oshù Shɛ́rɛ́","Oshù Èrèlè","Oshù Ɛrɛ̀nà","Oshù Ìgbé","Oshù Ɛ̀bibi","Oshù Òkúdu","Oshù Agɛmɔ","Oshù Ògún","Oshù Owewe","Oshù Ɔ̀wàrà","Oshù Bélú","Oshù Ɔ̀pɛ̀"]],u,[["BCE","AD"],u,["Saju Kristi","Lehin Kristi"]],1,[6,0],["d/M/y","d MM y","d MMM y","EEEE, d MMM y"],["H:m","H:m:s","H:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"XOF","F CFA","Faransì ìwɔ̀-oorùn Afíríkà",{"JPY":["JP¥","¥"],"NGN":["₦"],"RUB":["₽"]},"ltr", plural];
